export default __webpack_public_path__ + "static/media/t5.db2f3992.png";